var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "resbdguideunitsize" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "content-main" }, [
        _c("div", { staticClass: "House" }, [
          _c(
            "div",
            { staticClass: "HouseTop" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.buildHeadBeans.unitBeanList, function (i, n) {
                return _c("div", { key: n, staticClass: "HouseTop-item" }, [
                  _c("div", { staticClass: "HouseTop-item_name" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: i.name,
                          expression: "i.name",
                        },
                      ],
                      attrs: {
                        oninput:
                          "if(this.value.length > 10)this.value = value.slice(0, 10)",
                      },
                      domProps: { value: i.name },
                      on: {
                        blur: function ($event) {
                          return _vm.changeHoldname($event, n)
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(i, "name", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "HouseTop-item_house" }, [
                    i.sizeEdit
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: i.size,
                              expression: "i.size",
                            },
                          ],
                          attrs: {
                            type: "text",
                            oninput:
                              "this.value = this.value.replace(/[^0-9]/g, '');",
                          },
                          domProps: { value: i.size },
                          on: {
                            blur: function ($event) {
                              return _vm.changeHoldsize($event, n)
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(i, "size", $event.target.value)
                            },
                          },
                        })
                      : _c("span", [_vm._v(_vm._s(i.size))]),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "HouseMain" },
            _vm._l(_vm.floorBeanLists, function (i, n) {
              return _c(
                "div",
                { key: n, staticClass: "HouseMain-item" },
                [
                  _c("div", { staticClass: "HouseTop-item_unit" }, [
                    _c(
                      "div",
                      {
                        staticClass: "HouseTop-item_room",
                        staticStyle: { "min-width": "94px", color: "#999" },
                      },
                      [
                        _vm._v(
                          "\n                          " +
                            _vm._s(i.name) +
                            "层\n                      "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.buildHeadBeans.unitBeanList, function (i, n) {
                    return _c(
                      "div",
                      { key: n, staticClass: "HouseTop-item_unit" },
                      [
                        _c("div", { staticClass: "HouseTop-item_room" }, [
                          _vm._v(" " + _vm._s(i.size)),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "HouseTop-item" }, [
      _c("div", { staticClass: "HouseTop-item_name" }, [_vm._v("单元名称")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "HouseTop-item_house",
          staticStyle: { "min-width": "94px" },
        },
        [_vm._v("\n                        楼层/户数\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }